import { Link } from '@udemy/react-core-components';
import classNames from 'classnames';
import React from 'react';
import styles from "./card-title.module.css";

const renderNoLink = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
/**
 * ### CardTitle
 *
 * The title of a card, rendered with an optional link as the card's primary action.
 */


export const CardTitle = _ref2 => {
  let {
    children,
    headingLevel = 'h3',
    renderLink = renderNoLink,
    id
  } = _ref2;
  const HeadingElement = headingLevel;
  return /*#__PURE__*/React.createElement(HeadingElement, {
    id: id,
    className: classNames('ud-heading-lg', styles.title, 'ud-custom-focus-visible')
  }, renderLink({
    children: /*#__PURE__*/React.createElement("div", {
      className: styles.clipped
    }, children),
    className: classNames('ud-link-neutral', 'ud-custom-focus-visible')
  }));
};
/**
 * Helper function to render `CardTitle` link as vanilla anchor tag
 *
 * @param anchorProps - Props to pass to the anchor tag
 *
 * @remarks
 *
 * Use this function for the `renderLink` prop of `CardTitle`.
 **/

CardTitle.renderAnchorTag = _ref3 => {
  let {
    className: anchorClassName,
    ...anchorProps
  } = _ref3;
  return _ref4 => {
    let {
      children,
      className
    } = _ref4;
    return /*#__PURE__*/React.createElement("a", Object.assign({}, anchorProps, {
      className: classNames(anchorClassName, className)
    }), children);
  };
};
/**
 * Helper function to render `CardTitle` link as Udemy router `Link` component.
 *
 * @param linkProps - Props to pass to the `Link` component
 *
 * @remarks
 *
 * Use this function for the `renderLink` prop of `CardTitle`.
 *
 * @see {@link @udemy/react-core-components#Link | Link}
 **/


CardTitle.renderRouterLink = _ref5 => {
  let {
    className: linkClassName,
    ...linkProps
  } = _ref5;
  return _ref6 => {
    let {
      children,
      className
    } = _ref6;
    return /*#__PURE__*/React.createElement(Link, Object.assign({}, linkProps, {
      className: classNames(linkClassName, className)
    }), children);
  };
};
//# sourceMappingURL=card-title.react-component.js.map